export enum Feature {
    DeliveryDefense = '1',
    DigitalWallet = '2',
    CreditCard = '3',
    API = '4',
}
